import { render } from "./brandStart.vue?vue&type=template&id=595ecff2"
import script from "./brandStart.vue?vue&type=script&lang=js"
export * from "./brandStart.vue?vue&type=script&lang=js"

import exportComponent from "X:\\Proyecto\\riego-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__